module.exports = __webpack_public_path__ + "img/highroller_600.f7a8dae5.png";